enum NavigationBackground {
  Regular = 0,
  Light = 1,
  Dark = 2,
}

export default NavigationBackground;
